import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './UnreadLine.module.scss';
export const UnreadLine = ({ className, anchorRef }) => {
    const { t } = useTranslation();
    return (_jsxs("div", Object.assign({ ref: anchorRef, className: cn(styles.unreadMarker, className) }, { children: [_jsx("span", Object.assign({ className: styles.unreadMarkerText }, { children: t('label.new') })), _jsx("div", { className: styles.unreadMarkerLine })] })));
};
